"use client"

import Image from "next/image"
import { EnvironmentBadge } from "@/components/environment-badge"
import { usePlatformLogo } from "@/hooks/use-platform-logo"
import { useTranslations } from "next-intl"


export function AppStartupLoader() {
  const tUi = useTranslations("Shell.AppStartupLoader")
  const tCommonUi = useTranslations("Common")

  const { logoUrl } = usePlatformLogo()

  return (
    <div role="status" aria-live="polite" aria-label={tUi("loadingApplication")} className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center">
        <div className="mx-auto mb-4 flex items-center justify-center gap-2">
          <div className="w-12 h-12 flex items-center justify-center">
            <Image src={logoUrl} alt={tUi("logo")} width={144} height={48} className="h-12 w-auto" priority />
          </div>
          <EnvironmentBadge />
        </div>
        <div className="text-muted-foreground"><span key={tCommonUi("loading")}>{tCommonUi("loading")}</span></div>
      </div>
    </div>
  )
}
